// ValidationProvider.jsx
import React, { useState } from 'react';
import ValidationContext from './index';

// eslint-disable-next-line react/prop-types
const ValidationProvider = ({ children }) => {
  const [errors, setErrors] = useState([]);

  const validateInput = (type, name, value) => {
    let updatedErrors = { ...errors };

    if (type === "NAME_BASED") {
      switch (name) {
        // ✅ MID (15 char alphanumeric)
        case "mid":
          if (!/^[a-zA-Z0-9]{15}$/.test(value)) {
            updatedErrors.mid = "MID must be 15 alphanumeric characters";
          } else delete updatedErrors.mid;
          break;

        // ✅ Reference ID
        case "referenceId":
          if (!value) {
            updatedErrors.referenceId = "Reference ID is required";
          } else delete updatedErrors.referenceId;
          break;

        // ✅ REC Identifier (1 char)
        case "recIdentifier":
          if (!/^[A-Za-z0-9]{1}$/.test(value)) {
            updatedErrors.recIdentifier = "REC Identifier must be 1 character";
          } else delete updatedErrors.recIdentifier;
          break;

        // ✅ Institution Number (8 digits)
        case "institutionNumber":
          if (!/^[0-9]{8}$/.test(value)) {
            updatedErrors.institutionNumber = "Must be 8 digits";
          } else delete updatedErrors.institutionNumber;
          break;

        // ✅ Client Number (8 digits)
        case "clientNumber":
          if (!/^[0-9]{8}$/.test(value)) {
            updatedErrors.clientNumber = "Must be 8 digits";
          } else delete updatedErrors.clientNumber;
          break;

        // ✅ Trade Name
        case "tradeName":
          if (!value || value.length > 40) {
            updatedErrors.tradeName = "Max 40 characters";
          } else delete updatedErrors.tradeName;
          break;

        // ✅ Company Name
        case "companyName":
          if (!value || value.length > 60) {
            updatedErrors.companyName = "Max 60 characters";
          } else delete updatedErrors.companyName;
          break;

        // ✅ Short Name
        case "shortName":
          if (value && value.length > 40) {
            updatedErrors.shortName = "Max 40 characters";
          } else delete updatedErrors.shortName;
          break;

        // ✅ Registration Number
        case "registrationNumber":
          if (!value || value.length > 20) {
            updatedErrors.registrationNumber = "Max 20 characters";
          } else delete updatedErrors.registrationNumber;
          break;

        // ✅ Business Class (4 digits)
        case "businessClass":
          if (!/^[0-9]{4}$/.test(value)) {
            updatedErrors.businessClass = "Must be 4 digits";
          } else delete updatedErrors.businessClass;
          break;

        // ✅ Address fields
        case "merchantStreet":
        case "addressLine1":
        case "addressLine2":
        case "addressLine3":
          if (value && value.length > 40) {
            updatedErrors[name] = "Max 40 characters";
          } else delete updatedErrors[name];
          break;

        // ✅ City
        case "clientCity":
          if (!value || value.length > 35) {
            updatedErrors.clientCity = "Max 35 characters";
          } else delete updatedErrors.clientCity;
          break;

        // ✅ Country (3 digit code)
        case "clientCountry":
          if (!/^[0-9]{3}$/.test(value)) {
            updatedErrors.clientCountry = "Must be 3 digits";
          } else delete updatedErrors.clientCountry;
          break;

        // ✅ Condition Set
        case "conditionSet":
          if (!/^[0-9]{3}$/.test(value)) {
            updatedErrors.conditionSet = "Must be 3 digits";
          } else delete updatedErrors.conditionSet;
          break;

        // ✅ Contact Name
        case "contactName":
          if (value && value.length > 35) {
            updatedErrors.contactName = "Max 35 characters";
          } else delete updatedErrors.contactName;
          break;

        // ✅ Client Branch
        case "clientBranch":
          if (value && !/^[0-9]{3}$/.test(value)) {
            updatedErrors.clientBranch = "Must be 3 digits";
          } else delete updatedErrors.clientBranch;
          break;

        // ✅ Post Code (10 digits max)
        case "postCode":
          if (!/^[0-9]{1,10}$/.test(value)) {
            updatedErrors.postCode = "Invalid Post Code";
          } else delete updatedErrors.postCode;
          break;

        // ✅ Email
        case "emailId":
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(value)) {
            updatedErrors.emailId = "Invalid Email";
          } else delete updatedErrors.emailId;
          break;

        default:
          break;
      }
    }

    setErrors(updatedErrors);
  };

  return (
    <ValidationContext.Provider value={{ validateInput, errors, setErrors }}>
      {children}
    </ValidationContext.Provider>
  );
};

export default ValidationProvider;
